require('./addonList.scss');
const controller = require('./addonListCtrl').default;
const template = require('./addonList.html');

const deps = [
  require('ui/bk/angularMaterial').name,
  require('ui/bk/dndLists').name,
  require('data/model/ledger').name,
  require('data/model/addon').name,
];

module.exports = angular.module('bench.ui.addonList', deps).component('blAddonList', {
  bindings: {
    addonList: '<',
    subHead: '<',
    onEdit: '<',
    onDelete: '<',
    onReorder: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});
